/* eslint sort-keys: 1 */

import { IMG_BASE, baseConfig } from '@com/core/common/baseConfig';
import { TMarketplace, TMarketplaceConfig } from '../common/types/config';

export const IS_DOCKER_NON_DEV = process.env.DOCKER === 'yes' && process.env.ENV !== 'dev';
// eslint-disable-next-line no-underscore-dangle
export const MARKETPLACE = process.env._MARKETPLACE as TMarketplace;
// eslint-disable-next-line no-underscore-dangle
export const DOMAIN = process.env.ENV !== 'prod' ? `${MARKETPLACE}stg` : MARKETPLACE;

export const IS_BROWSER = typeof window !== 'undefined';
export const SVC_ENDPOINT = IS_BROWSER ? '/_svc' : `https://api-external.${DOMAIN}.com/_svc`;

const marketplaceConfig: TMarketplaceConfig & {
    assets: {
        icons: {
            bag: string;
        };
    };
    urls: {
        snapchat: string;
    };
} = {
    ...baseConfig,
    commonHeaders: {
        ...baseConfig.commonHeaders,
        'x-mp': 'sivvi',
    },
    endpoints: {
        ...baseConfig.endpoints,
        catalog:
            IS_DOCKER_NON_DEV && !IS_BROWSER
                ? 'http://catalog-sivvi-noratelimit/api'
                : SVC_ENDPOINT.replace('/_svc', '/_svc/catalog-sivvi/api'),
    },
    regions: {
        ...baseConfig.regions,
        ae: {
            ...baseConfig.regions.ae,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@sivvi.com',
            supportPhone: '80074884',
            tradeLicenseNumber: '661780',
            vatNumber: '100265405900003',
        },
        eg: {
            ...baseConfig.regions.eg,
            codLimit: 5000,
            enabled: false,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@sivvi.com',
            supportPhone: 'xxx',
        },
        sa: {
            ...baseConfig.regions.sa,
            codLimit: 5000,
            enabled: true,
            freeDeliveryCap: 100,
            paymentMethods: ['mastercard', 'visa', 'cod', 'amex'],
            supportEmail: 'care@sivvi.com',
            supportPhone: '8003014884',
            tradeLicenseNumber: '1010703009',
            vatNumber: '302004655210003',
        },
    },
    urls: {
        ...baseConfig.urls,
        appStore: 'https://apps.apple.com/ae/app/sivvi-online-shopping-%D8%B3%D9%8A%D9%81%D9%8A/id1052580577',
        colorSwatches: 'https://a.nooncdn.com/cms/pages/20181025/0ce4c3a5d392155933d4571ef91fc179',
        facebook: 'https://www.facebook.com/ShopSivvi/',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.sivvi.app&hl=en&gl=US',
        iconBase: `${baseConfig.urls.imgBase}/sivvi/icons/`,
        imgBase: `${baseConfig.urls.imgBase}/sivvi/images/`,
        instagram: 'https://www.instagram.com/shopsivvi/',
        linkedin: '',
        snapchat: 'https://www.snapchat.com/add/shopsivvi/',
        supportInfo: {
            careers: 'https://www.linkedin.com/company/nooncom/jobs/',
            helpCenterBase: 'https://help.sivvi.com/hc/',
            partners: `https://login.noon.partners/en/register`,
            privacyPolicy: '/privacy-policy',
            termsOfSale: '/terms-of-sale',
            termsOfUse: 'https://login.noon.partners/en/register',
            warrantyPolicy: '/warranty-policy',
        },
        twitter: '',
    },

    // eslint-disable-next-line sort-keys
    assets: {
        ...baseConfig.assets,
        icons: {
            ...baseConfig.assets.icons,

            address: '',
            arrowDiagonal: `${IMG_BASE}/sivvi/icons/arrow_diagonal.svg`,
            backArrow: `${IMG_BASE}/sivvi/icons/back.svg`,
            bag: `${IMG_BASE}/sivvi/icons/bag.svg`,
            caretDown: `${IMG_BASE}/sivvi/icons/caret-down.svg`,
            cart: '',
            cartBlack: `${IMG_BASE}/kul/images/icons/cart-black.svg`, // TODO: Upload to cdn and update the url
            cartBrand: '',
            cartWhite: '',
            check: ``,
            checkboxChecked: `${IMG_BASE}/sivvi/icons/checkbox_checked_v2.svg`,
            checkboxUnchecked: `${IMG_BASE}/sivvi/icons/checkbox_unchecked_v2.svg`,
            checkboxSquareChecked: `${IMG_BASE}/sivvi/icons/checkbox_square_checked.svg`,
            checkboxSquareUnchecked: `${IMG_BASE}/sivvi/icons/checkbox_square_unchecked.svg`,
            chevronDown: ``,
            claims: '',
            closeXBlack: `${IMG_BASE}/sivvi/icons/close_black.svg`,
            closeXWhite: `${IMG_BASE}/sivvi/icons/close_white.svg`,
            cod: `${IMG_BASE}/common/icons/cash.svg`,
            collectionPointsToggle: '',
            coupon: '',
            credits: '',
            edit: '',
            email: `${IMG_BASE}/sivvi/icons/email.svg`,
            facebook: `${IMG_BASE}/sivvi/icons/facebook_black.svg`,
            favicon: `${IMG_BASE}/sivvi/icons/favicon-v3.ico`,
            forwardArrow: `${IMG_BASE}/sivvi/icons/forward.svg`,
            gift: ``,
            globe: '',
            hamburger: '',
            help: `${IMG_BASE}/sivvi/icons/help.svg`,
            home: `${IMG_BASE}/sivvi/icons/home.svg`,
            info: ``,
            instagram: `${IMG_BASE}/sivvi/icons/instagram_black.svg`,
            magnifyingGlass: `${IMG_BASE}/sivvi/icons/magnifying-glass-v2.svg`,
            minus: `${IMG_BASE}/sivvi/icons/minus.svg`,
            nextDayDelivery: '',
            orders: '',
            payments: '',
            phone: `${IMG_BASE}/sivvi/icons/phone.svg`,
            plus: `${IMG_BASE}/sivvi/icons/plus.svg`,
            preferences: '',
            prepaidOnly: '',
            profile: '',
            reset: `${IMG_BASE}/sivvi/icons/reset.svg`,
            returns: '',
            search: `${IMG_BASE}/sivvi/icons/search.svg`,
            share: `${IMG_BASE}/sivvi/icons/share.svg`,
            shipment: '',
            shipmentMethod: {
                dd: '',
                fallback: '',
                sc: '',
                sdd: '',
            },
            shop: '',
            signOut: '',
            single_column: `${IMG_BASE}/sivvi/icons/single_column.svg`,
            single_column_selected: `${IMG_BASE}/sivvi/icons/single_column_selected.svg`,
            snapchat: `${IMG_BASE}/sivvi/icons/snapchat_black.svg`,
            trash: `${IMG_BASE}/kul/icons/remove-grey.svg`, // TODO: Upload to cdn and update the url
            two_column: `${IMG_BASE}/sivvi/icons/two_column_v2.svg`,
            two_column_selected: `${IMG_BASE}/sivvi/icons/two_column_selected.svg`,
            user: `${IMG_BASE}/sivvi/icons/user.svg`,
            wishList: `${IMG_BASE}/sivvi/icons/wishlist.svg`,
            wishListAdded: `${IMG_BASE}/sivvi/icons/wishlist_selected.svg`,
            wishListBlack: `${IMG_BASE}/kul/icons/wishlist-black.svg`, // TODO: Upload to cdn and update the url
            wishListEmpty: `${IMG_BASE}/sivvi/icons/empty_wishlist.svg`,
        },
        images: {
            ...baseConfig.assets.images,
            addressCollectionIndicator: '',
            addressLatLngIndicator: '',
            addressesEmptySlate: '',
            appStore: `${IMG_BASE}/sivvi/images/appstore_black.svg`,
            bankTransferEmpty: '',
            cartEmpty: '',
            chevronRight: '',
            chevronRightWhite: '',
            claimAmountExceeded: '',
            claimsEmptySlate: '',
            claimsSuccessSlate: '',
            claimsTypeChecked: '',
            claimsTypeDamage: '',
            claimsTypeProtection: '',
            claimsTypeUnchecked: '',
            defaultMap: '',
            defaultProductPlaceholder: '',
            emptySearch: '',
            error404: '',
            error500: '',
            fulfilmentExpressAr: '',
            fulfilmentExpressEn: '',
            fulfilmentPreOrderAr: '',
            fulfilmentPreOrderEn: '',
            fulfilmentMarketplaceEn: '',
            fulfilmentMarketplaceAr: '',
            googlePlay: `${IMG_BASE}/sivvi/images/googleplay_black.svg`,
            logoBG: '',
            loyalty: {
                bulletCheck: '',
                bulletStar: '',
                tick: '',
                vip: '',
                vipAR: '',
                vipEN: '',
            },
            mapCollectionPointLocker: '',
            mapCollectionPointPickup: '',
            mapCollectionPointToggle: '',
            mapLandmarkPin: '',
            mapLocateMeAr: '',
            mapLocateMeEn: '',
            openGraphImage: '',
            paymentEmptySlate: '',
            returnSuccess: '',
            returnablesEmptyState: '',
            returnsEmptyState: '',
            secure: '',
            toggleActive: '',
            toggleInactive: '',
            transferRequestSuccess: '',
        },
    },

    categories: ['women', 'men', 'kids'],
    defaultCategory: 'women',

    headerSupportBar: false,

    // eslint-disable-next-line sort-keys
    gtm: {
        ...baseConfig.gtm,
        gaID: 'UA-84507530-19',
        gtmID: 'GTM-T3955H7',
        optimizeID: 'xxx',
    },

    // eslint-disable-next-line sort-keys
    enabledFeatures: {
        etracking: true,
        loyalty: false,
        fingerprinting: true,
    },

    etracking: {
        url: 'https://etracker.noon.com/track',
        id: 'sivvi',
    },
};

export default marketplaceConfig;
